<template>
  <div>
    <header>
      <Navbar id="navbars" />
      <!-- <div :style="{ height: toHeight }"></div> -->
    </header>
    <div class="q">
      <SwiperViews
        :bannerlist="bannerlist"
        v-if="ifshowbannner"
        :height="swiperheight"
        :showswiper="showswiper"
      />
    </div>
    <div class="Store_bg" id="componys">
      <div class="Store_img"></div>
      <Compony />
      <NationalStores />
    </div>

    <Enterprise @showimg="showimg" :showswiper="showswiper" />
    <Shopping id="shoppings" />
    <AppFooter />
    <div v-if="show" class="picture_box">
      <img
        src="@/assets/out.png"
        alt=""
        class="picture_box_out"
        @click="closeshow()"
      />
      <div class="picture_innerbox">
        <img
          :src="$url + picture"
          alt=""
          :style="{
            width: width + 'px',
            height: height + 'px',
            transform: `translate(-50%, -50%) rotate(${rotate}deg)`,
          }"
          class="picture_box_img"
        />
      </div>
      <img
        src="@/assets/revolve2.png"
        alt=""
        class="revolve_left"
        @click="leftvolve()"
      />
      <img
        src="@/assets/revolve1.png"
        alt=""
        class="revolve_right"
        @click="rightvolve()"
      />
    </div>
  </div>
</template>

<script>
import "./utils/animate.css";
import AppFooter from "./views/AppFooter.vue";
import Compony from "./views/Compony.vue";
import Enterprise from "./views/Enterprise.vue";
import NationalStores from "./views/NationalStores.vue";
import Navbar from "./views/Navbar.vue";
import Shopping from "./views/Shopping.vue";
import SwiperViews from "./views/SwiperViews.vue";

export default {
  name: "app",
  data() {
    return {
      bannerlist: [],
      ifshowbannner: false,
      width: 0,
      height: 0,
      show: false,
      picture: "",
      swiperheight: 0,
      showswiper: true,
      toHeight: 0,
      rotate: 0,
    };
  },
  mounted() {
    this.swiperheight = window.innerHeight - 60;
    this.width = window.innerWidth;
    this.height = window.innerHeight - 130;
    this.$http
      .post("/index/banner/list", {
        type: "index",
      })
      .then((res) => {
        this.bannerlist = res.data.data;
        this.ifshowbannner = true;
      });
    window.onresize = () => {
      this.showswiper = false;
      this.swiperheight = window.innerHeight;
      this.width = window.innerWidth;
      this.height = window.innerHeight - 130;
      this.$nextTick(() => {
        this.showswiper = true;
      });
    };
    // this.getHeight()
    // window.addEventListener('resize',this.getHeight())
  },
  // destroyed(){
  //   window.removeEventListener('resize',this.getHeight())
  // },
  methods: {
    // getHeight(){
    //   this.toHeight = document.getElementById('navbars').clientHeight+"px"
    //   console.log(document.getElementById('navbars').clientHeight);
    // },
    closeshow() {
      this.show = false;
      this.rotate = 0;
    },
    leftvolve() {
      this.rotate += 90;
    },
    rightvolve() {
      this.rotate -= 90;
    },
    showimg(item, i) {
      this.picture = item[i].picture;
      this.show = true;
    },
  },
  components: {
    Navbar,
    SwiperViews,
    Compony,
    NationalStores,
    Enterprise,
    Shopping,
    AppFooter,
  },
};
</script>

<style  lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.revolve_left {
  position: fixed;
  width: 50px;
  bottom: 20px;
  right: 50vw;
  cursor: pointer;
}
.revolve_right {
  position: fixed;
  width: 50px;
  bottom: 20px;
  left: 50vw;
  cursor: pointer;
}
.picture_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: #0008;
  top: 0;
  left: 0;
  z-index: 9999;
  .picture_innerbox {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .picture_box_img {
    height: 100vh;
    position: absolute;
    top: 50%;
    left: 50%;
    object-fit: contain;
    transform-origin: center center;
    transition: all 0.1s linear;
  }
  .picture_box_out {
    z-index: 99999;
    position: fixed;
    right: 30px;
    top: 30px;
    width: 40px;
    cursor: pointer;
  }
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ecf5ff;
  color: #00a4a7;
}
.q {
  padding-top: 88px;
  @media (max-width: 1366px) {
    padding-top: 60px;
  }
  @media (max-width: 768px) {
    padding-top: 60px;
  }
  .swiper {
    // width: 200vw !important;
  }
  img {
    object-fit: fill !important;
  }
}
img {
  object-fit: cover;
}
.Store_bg {
  position: relative;
  width: 100%;
  height: 100%;
}
.Store_img {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  opacity: 0.4;
  background-image: url("./assets/storebg.png");
}
.swiper {
  .swiper-pagination-bullet-active {
    background-color: #00a4a7 !important;
  }
  .swiper-slide {
    @media (min-width: 1366px) {
      // width: 70vw !important;
    }
    filter: opacity(0.4);
  }
  .swiper-slide-active {
    filter: opacity(1);
    @media (min-width: 1366px) {
      // width: 1141px !important;
    }
  }
  @media (min-width: 1366px) {
    .swiper-slide-prev {
      // width: 837px !important;
    }
    .swiper-slide-next {
      // width: 1141px !important;
    }
  }
  // .swiper-slide-prev{
  //   width: 44% !important;
  // }
  // .swiper-slide-next{
  //   width: 60% !important;
  // }
  .swiper-slide {
    transition: all 0.3s linear !important;
  }
  .swiper-button-prev::after {
    display: none !important;
  }
  .swiper-button-next::after {
    display: none !important;
  }
}
.el-carousel__indicators--outside {
  display: none !important;
}

.el-carousel__item {
  .swiper_box {
    opacity: 0.7;
  }
  // width: 50% !important;
  // transform: scale(0.77) !important;
}
.is-active {
  // transform:scale(1) ;
  .swiper_box {
    transition: all 0.4s linear;
    opacity: 1;
  }
}
.el-carousel__mask {
  // text-align: center;
  // margin: 0 auto;
  // width: 223px;
  // left: 50%;
  // transform: -50%,-50% !important;
  display: none !important;
  // background-color: #fff0;
}
.el-carousel__arrow {
  background-color: #00a4a7 !important;
  border: 4px solid #fff !important;
  font-size: 18px !important;
  > i {
    font-weight: bold !important;
  }

  transform: -50% -50% !important;
}
.el-carousel__arrow:hover {
  background-color: #00a4a7 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue